<template>
  <Container>
    <LoadingOverlay
      :hasBlur="false"
      isLight
      :visible="showLoader"
    />
    <Card
      v-if="!isEnterpriseEnrolled && !showLoader"
      hasNoBorder
    >
      <HeadingMedium>
        {{ preEnrollmentText.title }}
      </HeadingMedium>
      <ParagraphBody
        :class="$style.playContainer"
      >
        <svg width="188" height="106" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M139.876 32.094l15.601-27.021a3.246 3.246 0 00-5.621-3.245L134.059 29.19c-12.082-5.513-25.648-8.583-40.126-8.583-14.478 0-28.044 3.07-40.126 8.583L38.01 1.828a3.245 3.245 0 00-5.62 3.245l15.6 27.02C21.203 46.665 2.88 73.789.199 105.83h187.47c-2.68-32.042-21.004-59.166-47.792-73.736zM50.791 79.117c-4.305 0-7.807-3.502-7.807-7.807 0-4.304 3.502-7.807 7.806-7.807 4.305 0 7.807 3.503 7.807 7.807 0 4.305-3.502 7.807-7.806 7.807zm86.286 0c-4.305 0-7.807-3.502-7.807-7.807 0-4.304 3.502-7.807 7.807-7.807 4.304 0 7.806 3.503 7.806 7.807 0 4.305-3.502 7.807-7.806 7.807z" fill="#3DDC84"/></svg>
        <HeadingLarge
          :class="[$style.marginTopSpacer, $style.alignCenter]"
        >
          {{ preEnrollmentText.header }}
        </HeadingLarge>
        <ParagraphBody
          :class="[$style.alignCenter, $style.marginTopSpacer]"
        >
          {{ preEnrollmentText.getYourSetupText }}
        </ParagraphBody>
        <Button
          :class="$style.marginTopSpacer"
          :text="preEnrollmentText.buttonText"
          textCase="capitalize"
          @click="handleEmmEnrollment"
        />
      </ParagraphBody>
    </Card>
    <Card
      v-if="isEnterpriseEnrolled"
      hasNoBorder
    >
      <div :class="$style.titleBlock">
        <HeadingMedium :class="$style.title">
          {{ addAndroidDevice.byodTitle }}
        </HeadingMedium>
        <TooltipIcon
          isMarkdown
          orientation="bottom"
          :text="userConfig.configBodyTooltip"
        />
      </div>
      <ParagraphBody>
        <MarkdownInline :mdTemplate="userConfig.configBodyText" />
      </ParagraphBody>
      <template v-slot:footer>
        <GoogleEmmDynamicSelectModal v-if="showDynamicSelectModal" />
      </template>
    </Card>
    <QrCodeEnrollmentModal
      v-if="isShowEnrollmentInstructions"
      :enterpriseObjectId="enterpriseResponseBody.enterpriseObjectId"
      :headerText="headerText"
      :organizationObjectId="enterpriseResponseBody.organizationObjectId"
      @close-enrollment-instructions="handleEnrollmentInstructionClose"
    />
    <Card
      v-if="isEnterpriseEnrolled"
      hasNoBorder
    >
      <div :class="$style.titleBlock">
        <HeadingMedium :class="$style.title">
          {{ addAndroidDevice.copeTitle }}
        </HeadingMedium>
        <TooltipIcon
          isMarkdown
          orientation="bottom"
          :text="adminConfig.configBodyTooltip"
        />
      </div>
      <ParagraphBody>
        <MarkdownInline :mdTemplate="adminConfig.configBodyText" />
      </ParagraphBody>
      <template v-slot:footer>
        <ParagraphBody>
          <ButtonSecondary
            :text="addAndroidDevice.copeBody.buttonText"
            @click="handleEnrollmentInstruction"
          />
        </ParagraphBody>
      </template>
    </Card>
  </Container>
</template>

<script>
import {
  AndroidEmmConsts,
  ItemTypeConsts,
  ItemTypeRoutes,
  StoreModuleMap,
} from 'client/util/Constants';
import {
  Button,
  ButtonSecondary,
  Card,
  Container,
  HeadingLarge,
  HeadingMedium,
  LoadingOverlay,
  MarkdownInline,
  ParagraphBody,
  TooltipIcon,
} from '@jumpcloud/ui-components';
import { mapActions } from 'vuex';
import GoogleEmmDynamicSelectModal from 'client/MDM/components/GoogleEmmDynamicSelectModal.vue';
import GoogleMdmApi from 'client/api/v2/GoogleMdmApi';
import QrCodeEnrollmentModal from 'client/MDM/components/QrCodeEnrollmentModal.vue';
import Util from 'client/util/Util';

const googleModule = StoreModuleMap[ItemTypeConsts.mdmGoogle];

export default {
  name: 'CreateAndroidDevice',

  components: {
    Button,
    ButtonSecondary,
    Card,
    Container,
    GoogleEmmDynamicSelectModal,
    HeadingLarge,
    HeadingMedium,
    LoadingOverlay,
    MarkdownInline,
    ParagraphBody,
    TooltipIcon,
    QrCodeEnrollmentModal,
  },

  data: () => ({
    addAndroidDevice: AndroidEmmConsts.creatAndroidDeviceText,
    adminConfig: AndroidEmmConsts.androidEmmAdminConfigText,
    enterpriseResponseBody: null,
    headerText: AndroidEmmConsts.androidEmmQrEnrollmentText.title,
    isEnterpriseEnrolled: false,
    isShowEnrollmentInstructions: false,
    preEnrollmentText: AndroidEmmConsts.androidEnterprisePreEnrollmentText,
    routeEMM: `/${ItemTypeRoutes[ItemTypeConsts.mdmSettings]}`,
    showDynamicSelectModal: false,
    showLoader: true,
    userConfig: AndroidEmmConsts.androidEmmUserConfigText,
  }),

  mounted() {
    this.handleMounted();
  },

  methods: {
    ...mapActions(googleModule, [
      'updateGoogleEmmEnterpriseObjState',
    ]),

    handleEmmEnrollment() {
      Util.redirect(`${this.routeEMM}/google`);
    },

    handleEnrollmentInstruction() {
      this.isShowEnrollmentInstructions = true;
    },

    handleEnrollmentInstructionClose() {
      this.isShowEnrollmentInstructions = false;
    },

    async handleMounted() {
      try {
        const getEnterpriseRsp = await GoogleMdmApi.getEnterprise();
        if (getEnterpriseRsp.count) {
          const resIndex = getEnterpriseRsp.count - 1;
          this.enterpriseResponseBody = {
            enterpriseObjectId: getEnterpriseRsp.enterprises[resIndex].objectId,
            organizationObjectId: getEnterpriseRsp.enterprises[resIndex].organizationObjectId,
            allowDeviceEnrollment: getEnterpriseRsp.enterprises[resIndex].allowDeviceEnrollment
              ? getEnterpriseRsp.enterprises[resIndex].allowDeviceEnrollment
              : false,
            deviceGroupId: getEnterpriseRsp.enterprises[resIndex].deviceGroupId
              ? getEnterpriseRsp.enterprises[resIndex].deviceGroupId
              : '',
          };
          this.updateGoogleEmmEnterpriseObjState(this.enterpriseResponseBody);
          this.showDynamicSelectModal = true;
          this.isEnterpriseEnrolled = true;
        } else {
          this.isEnterpriseEnrolled = false;
        }
      } catch {
        this.isEnterpriseEnrolled = false;
      } finally {
        this.showLoader = false;
      }
    },
  },
};
</script>

<style module>
.titleBlock {
  border-bottom: var(--jc-border);
  flex: 0 0 65%;
  height: 3rem;
  margin-bottom: var(--jc-spacer);
  padding-bottom: var(--jc-spacer);
}

.title {
  display: inline-block;
}

.marginTopSpacer {
  margin-top: var(--jc-spacer) !important;
}

.alignCenter {
  text-align: center;
}

.playContainer {
  align-items: center;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  height: 100%;
  justify-content: center;
  margin-top: 3.125rem !important;
  width: 100%;
}
</style>
